import React, { useState, useEffect } from 'react';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import './trailbadge.css';

const Trialbadge = ({ demoExpiryTime }) => {

  const calculateRemaining = () => {
    if (!demoExpiryTime) return 0;

    const expiry = new Date(demoExpiryTime).getTime();
    const now = Date.now();

    return Math.max(0, expiry - now);
  };

  const [remainingTime, setRemainingTime] = useState(
    calculateRemaining
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(calculateRemaining());
    }, 1000);

    return () => clearInterval(interval);
  }, [demoExpiryTime]);


  // =========================================
  // Time calculations
  // =========================================

  const totalSeconds = Math.floor(remainingTime / 1000);

  const days = Math.floor(totalSeconds / 86400);

  const hours = Math.floor(
    (totalSeconds % 86400) / 3600
  );

  const minutes = Math.floor(
    (totalSeconds % 3600) / 60
  );

  const seconds = totalSeconds % 60;


  const formatTime = (value) => {
    return String(value).padStart(2, '0');
  };


  // =========================================
  // Expiry text
  // =========================================

  const getExpiryText = () => {

    // Trial expired
    if (remainingTime <= 0) {
      return 'Trial expired';
    }


    // More than or equal to 24 hours
    if (totalSeconds >= 86400) {

      return `Expires in ${days} ${
        days === 1 ? 'day' : 'days'
      }`;
    }


    // Between 1 hour and 24 hours
    if (totalSeconds >= 3600) {

      return `Expires in ${hours}h ${formatTime(minutes)}m`;
    }


    // Less than 1 hour
    return `Expires in ${minutes}m ${formatTime(seconds)}s`;
  };


  return (
    <div className="trial-badge">

      <div className="trial-badge-title">

        <VisibilityOffIcon />

        <span>
          Trial Link
        </span>

      </div>


      <div className="trial-badge-expiry">

        {getExpiryText()}

      </div>

    </div>
  );
};

export default Trialbadge;